
export class WizardQuestionAnswer {

    constructor(public id: number, public question: string, public title: string) {
        this.id = id;
        this.question = question;
    }

    answers = new Array<Answer>();
    textAnswers = new Array<TextAnswer>();
    selectedAnswer: string;

    addAnswer(id:number, answer: string, nextQuestionId: number) {
        const a = new Answer(id, answer, nextQuestionId);
        this.answers.push(a);
    }

    addTextAnswer(question: string, placeholder: string, inputType: string, required: boolean) {
        const at = new TextAnswer(question, placeholder, inputType, required);
        this.textAnswers.push(at);
    }
}

export class Answer {
    constructor(id: number, answer: string, nextQuestionId: number) {
        this.id = id;
        this.answer = answer;
        this.nextQuestionId = nextQuestionId;
    }

    id: number;
    answer: string;
    nextQuestionId: number;
}

export class TextAnswer {
    constructor(public question: string, public placeholder: string, public inputType: string, public required: boolean) { }

    answer: string;
}